import React from 'react';
import PropTypes from 'prop-types';

import styles from './Separator.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const Separator = props => (
  <div className={[props.className, styles.container].join(' ')} />
);

Separator.propTypes = IPropTypes;
Separator.defaultProps = defaultProps;

export { Separator };



// WEBPACK FOOTER //
// ./src/pages/product-detail/separator/Separator.jsx